export function getSurveyImageUrls(fileUrl) {
    if (!fileUrl) {
        return { fullUrl: null, thumbnailUrl: null };
    }
    const safeReturn = () => ({
        fullUrl: fileUrl,
        thumbnailUrl: fileUrl,
    });
    try {
        const full = new URL(fileUrl);
        full.searchParams.delete('showThumbnail');
        const thumb = new URL(full.toString());
        if (fileUrl.includes('/files/')) {
            thumb.searchParams.set('showThumbnail', 'true');
        }
        return { fullUrl: full.toString(), thumbnailUrl: thumb.toString() };
    }
    catch {
        return safeReturn();
    }
}
